import { render, staticRenderFns } from "./ModalResourceInfo.vue?vue&type=template&id=75d934dd&"
import script from "./ModalResourceInfo.vue?vue&type=script&lang=js&"
export * from "./ModalResourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalResourceInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports